export const localStorageKey = clientId => `ADVWorkflow.AreYouMarriedAnswered[${clientId}]`;

const shouldSkip = (isGoingForward, alreadyHadPartnerData, clientId) => {
  if (
    isGoingForward &&
    (alreadyHadPartnerData || localStorage.getItem(localStorageKey(clientId)) === 'true')
  ) {
    return true;
  }

  return false;
};

export default shouldSkip;
